import { render } from "./MyPopUpWindowFooterButtonAttachFile.vue?vue&type=template&id=2012e1b5"
import script from "./MyPopUpWindowFooterButtonAttachFile.vue?vue&type=script&lang=js"
export * from "./MyPopUpWindowFooterButtonAttachFile.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__